import { useAuth0 } from '@auth0/auth0-react';
import { useBoolean, useTimeout } from 'usehooks-ts';

import { LogoSimple } from './logo-simple';

export type AuthLoadingProps = {};

export function AuthLoading(_: AuthLoadingProps) {
  const auth0 = useAuth0();
  const preventFlikering = useBoolean(true);
  const showRetry = useBoolean(false);

  useTimeout(showRetry.setTrue, 8_000);
  useTimeout(preventFlikering.setFalse, 1_000);

  async function handleRefresh() {
    try {
      await auth0.logout({
        logoutParams: { returnTo: window.location.origin },
      });
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
    }
  }

  if (preventFlikering.value) {
    return null;
  }

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-8">
      <div>
        <LogoSimple className="h-12" />
      </div>
      {showRetry.value ? (
        <p className="max-w-prose text-center text-gray-500">
          It seems something went wrong.
          <br />
          If the issue persists, please click this link to{' '}
          <button
            className="text-blue-500 hover:underline"
            onClick={handleRefresh}
          >
            restart into a fresh session
          </button>
          .
        </p>
      ) : (
        <div className="animate animate-pulse text-gray-500">loading ...</div>
      )}
    </div>
  );
}
